import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
/* eslint-disable @nx/enforce-module-boundaries */
import { InputComponent } from 'libs/ui/src/lib/input/input.component';

@Component({
  selector: 'rmb-additional-surcharge',
  templateUrl: './additional-surcharge.component.html',
  styleUrl: './additional-surcharge.component.scss',
  standalone: false,
})
export class AdditionalSurchargeComponent {
  readonly TRANSLOCO_PREFIX = 'stations.additionalSurcharges';

  @ViewChildren(InputComponent) inputs: QueryList<InputComponent>;
  @Input() form: FormGroup;
  @Input() errorMessage?: string;
  @Input() required = false;
  @Input() sideLoaderRequired = false;
  @Input() tipper20Required = false;
  @Input() tipper40Required = false;
  @Input() valueSources: Record<string, 'createdSurcharge'> = {};

  isCreated(field: string): boolean {
    return this.valueSources?.[field] === 'createdSurcharge';
  }

  resetAllTyped() {
    this.inputs.forEach((input) => input.resetTyped());
  }
}
